<template>
  <transition name="modal-fade" class="modal-fade">
      <div class="modal-backdrop" id="Modal">
        <form class="form-horizontal" @submit.prevent="addOrUpdate" action="#" method="post">
          <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height:700px">
            <header class="modal-header">
              <slot name="header">           
                {{popupTitle}}
                <div class="closeButton">
                  <!-- <button type="button" class="btn" @click="close">Close</button> -->
                </div>
              </slot>
            </header>
            <section class="modal-body">
              <slot name="body">            
                  <div class="row m-0">
                    <div class="form-group">
                      <label for="campaign" class="col-sm-3 control-label">Campaign</label>
                      <div class="col-sm-9">
                        <input type="text" class="form-control" id="campaign" name="campaign" placeholder="Campaign" disabled v-model="gRowObj.campaign">
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="Message" class="col-sm-3 control-label">Message Name</label>
                      <div class="col-sm-9">
                        <input :disabled="gRowObj.campaign==='APP_LAUNCH' && popupTitle === 'Update Message'" type="text" autocomplete="off" class="form-control" id="Message" name="Message"  placeholder="Message Name" v-model="gRowObj.message" v-bind:class="{'form-group--error': (submitted && !$v.gRowObj.message.required) || (submitted && !$v.gRowObj.message.messageRegex) || keywordExistError }"></div>
                        <span v-if="submitted && !$v.gRowObj.message.required" class="text-red pull-right" style="margin-right:14px">Message Name is Required</span>
                        <span v-if="submitted && keywordExistError" class="text-red pull-right" style="margin-right:14px">Message already exists.</span>
                        <span v-if="submitted && !$v.gRowObj.message.messageRegex" class="text-red pull-right" style="margin-right:14px">Invalid Format</span>                
                    </div>
                    <div v-if="gRowObj.campaign==='APP_LAUNCH'" class="form-group">
                      <label for="DisplayText" class="col-sm-3 control-label">Display Name</label>
                      <div class="col-sm-9">
                        <input  type="text" autocomplete="off" class="form-control" id="DisplayText" name="DisplayText" placeholder="Display Name" v-model="gRowObj.displayText"></div>
                    </div>
                    <div v-if="gRowObj.campaign==='APP_LAUNCH'" class="form-group">
                      <label for="isCustomMessage" class="col-sm-3 control-label">Custom Message</label>
                      <div class="radio-is-welcome-div">
                        <label class="radio-inline col-xs-6 col-sm-6 col-md-6">
                          <input v-model="gRowObj.isCustomMessage" :checked="gRowObj.isCustomMessage" type="radio" :value="true" name="isCustomMessage">Yes
                        </label>
                        <label class="radio-inline col-xs-6 col-sm-6 col-md-6">
                          <input v-model="gRowObj.isCustomMessage" :checked="gRowObj.isCustomMessage" type="radio" :value="false" name="isCustomMessage">No
                        </label>
                      </div>
                    </div>

                    <div style="justify-self: right; margin-bottom: 10px;">
                      <input type="button" v-on:click="translate()" class="btn btn-add-message" value="Translate" style="font-weight: bold; color: white; background-color: #0D9488;"/>
                      <input type="button" v-on:click="lockAll()" class="btn btn-add-message" value="Lock All" style="font-weight: bold; color: white; background-color: #ADCEC5;"/>
                      <input type="button" v-on:click="unlockAll()" class="btn btn-add-message" value="Unlock All" style="font-weight: bold; color: white; background-color: #ADCEC5;"/>
                    </div>

                    <div v-if="gRowObj.rowObj.language && Object.keys(gRowObj.rowObj.language).length">
                      <div v-bind:key="key" v-for="(langRow, key) in gRowObj.rowObj.language">
                         <div class="form-group">
                          <div>
                          <label for="primarylanuage" class="col-sm-3 control-label">{{langRow.langName}}
                            <br/>
                            <label v-if="langRow.langName!=='English'" class="switch" style="margin-top: 10px">
                              <input type="checkbox" v-model="translateSwitch[langRow.langShortcode]">
                              <span class="slider round"></span>
                            </label>  
                          </label>
                          </div>
                          <div class="col-sm-9" v-if="typeof langRow.message === 'string'">
                            <textarea type="text" class="form-control" placeholder="" rows="4" v-model="langRow.message"></textarea>
                          </div>
                         </div>
                      </div>
                    </div>
                  
                    <div v-if="gRowObj.rowObj.country && Object.keys(gRowObj.rowObj.country).length">
                      <div v-bind:key="key" v-for="(countryRow, key) in gRowObj.rowObj.country">
                         <div class="form-group">
                          <label for="primarylanuage" class="col-sm-3 control-label">{{countryRow.country}}</label>
                          <table class="col-sm-9" style="width=100%"  v-if="countryRow.languages && Object.keys(countryRow.languages).length">
                              <tr v-bind:key="key" v-for="(languageRow, key) in countryRow.languages">
                                <td style="width:12%;  background-color:#f3f2f2;">{{languageRow.langName}}
                                 <label v-if="countryRow.country !== 'Global'" class="switch" style="margin-top: 10px">
                                  <input type="checkbox" v-model="translateSwitch[countryRow.country][languageRow.langCode]">
                                  <span class="slider round"></span>
                                </label>  
                                </td>
                                <td> <textarea type="text" class="form-control" placeholder="" rows="4" v-model="languageRow.message"></textarea></td>
                              </tr>
                          </table>
                        
                         </div>
                      </div>
                    </div>

                    <!-- <div class="form-group">
                      <label for="primarylanuage" class="col-sm-3 control-label">{{primaryLangText}}</label>
                      <div class="col-sm-9">
                        <textarea type="text" class="form-control" id="primarylanguage" name="primarylanguage" placeholder="Primary Language"  v-model="gRowObj.primaryLanguageMsg"></textarea></div>
                    </div>
                    <div class="form-group">
                      <label for="secondarylanguage" class="col-sm-3 control-label">{{secondaryLangText}}</label>
                      <div class="col-sm-9">
                        <textarea type="text" class="form-control" id="secondarylanguage" name="secondarylanguage" placeholder="Secondary Language" v-model="gRowObj.secondaryLanguageMsg"></textarea></div>
                    </div> -->
                   <!-- <div class="form-group">
                      <div class="col-sm-offset-2 col-sm-10">
                        <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                        <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                      </div>
                    </div> -->
                     
                </div>  
              </slot>    
            </section>  
            <footer class="modal-footer">
                      <slot name="footer">
                        <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                        <input type="submit" class="btn btn-primary" value="Submit">
                    </slot>
                  </footer>     
          </div>
        </form>
        <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
      </div>
    </transition>
</template>
<script>
// import { logout, createUser } from '../../../utils/auth'
import { required, helpers } from 'vuelidate/lib/validators'
import api from '../../../utils/api'
import { getActiveCountryList, isButtonTextGreaterThan20Chars } from '../../../utils/utilities'
const messageRegex = helpers.regex('alpha', /^[a-zA-Z0-9_\-.]*$/)
export default {
  name: 'app-all-rows',
  validations: {
    gRowObj: {
      message: {
        required,
        messageRegex
      }
    }
  },
  props: ['gRowObj', 'primaryLangText', 'secondaryLangText', 'allRows', 'popupTitle'],
  async mounted () {
    this.currentCustomMessageStatus = this.gRowObj.isCustomMessage
    this.activeCountryList = await getActiveCountryList('uppercase', true)
    this.setTranslateSwitch(false)
  },
  methods: {
    /**
     * @function OpenPOP
     * @description Function to open popup any message content for the
     * @param {string} primary - Message in primary language
     * @param {string} secondary - Message in secondary language
     * @param {string} message - Message Key
     * @param {string} campaignId - Campaign Id
     */
    OpenPOP (primary, secondary, message, campaignId) {
      // this.showModal = true
      console.log('gRowObj', this.gRowObj)
      this.loading = false
      console.log('sheet id', this.$route.query.id)
      console.log(`message=${message}`)
      if (message !== '') {
        this.popupTitle = 'Update Message'
        this.returnMessage = this.popupTitle
      } else {
        this.returnMessage = this.popupTitle
      }
      this.gRowObj.campaign = this.$route.query.sheetTitle
      this.gRowObj.id = campaignId
      this.gRowObj.primaryLanguageMsg = primary
      this.gRowObj.secondaryLanguageMsg = secondary
      // this.gRowObj.message = message
      this.messageData = message
      console.log('messageData', this.messageData)
      this.$emit('add-message', this.gRowObj)
      // this.loading = true
    },
    close () {
      this.$emit('closeModal', true)
      this.keywordExistError = false
      this.loading = false
    },
    removeStage (stageName) {
      this.$emit('remove', stageName)
    },
    /**
     * @function editStage
     * @description edit a stage on the app flow
     * @param {string} stageName - name of the stage
     */
    editStage (stageName) {
      this.$emit('edit', stageName)
    },
    checkValidations (preStr, btnArray, optionArray, messageText) {
      if (btnArray || optionArray) {
        let messageAfterButtonOrListRemoved = messageText.trim().replace(/{{(.+?)}}|\[\[(.*?)\]\]/g, '')
        if (!messageAfterButtonOrListRemoved) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4>
              <h5>Please enter some plain text while using Buttons and Lists</h5>`
            }
          }
        }
      }
      if (Array.isArray(btnArray)) {
        for (let str of btnArray) {
          str = str.trim()
          if (!str) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Please Add Button text</h5>`
              }
            }
          } else if (isButtonTextGreaterThan20Chars(str)) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Button text should be less than 20 characters</h5>`
              }
            }
          }
        }
      }
      if (Array.isArray(btnArray) && btnArray.length > 10) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4> 
            <h5>Maximum of 10 options allowed for buttons/lists.</h5>
            <h5>Please use plain text format if more than 10 options are needed.</h5>`
          }
        }
      }
      if ((Array.isArray(btnArray) && btnArray.length <= 3) && (Array.isArray(optionArray) && optionArray.length)) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4> 
            <h5>List options not needed for less then 3 buttons</h5>`
          }
        }
      }
      if ((Array.isArray(btnArray) && btnArray.length > 3 && !btnArray[0].includes('NINETY')) && (!optionArray || !optionArray.length)) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4>
            <h5>List options needed for more than 3 buttons.</h5>
            <h5>Please add list option like [[List Button Text]]</h5>`
          }
        }
      }
      if ((!btnArray || !btnArray.length) && (Array.isArray(optionArray) && optionArray.length)) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4> 
            <h5>Add list option when more then 3 buttons</h5>`
          }
        }
      }
      if (Array.isArray(optionArray)) {
        for (let str of optionArray) {
          str = str.trim()
          if (!str) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Please Add list option text</h5>`
              }
            }
          } else if (isButtonTextGreaterThan20Chars(str)) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>List option text should be less than 20 characters</h5>`
              }
            }
          }
        }
      }
      if (Array.isArray(optionArray) && optionArray.length > 1) {
        return {
          resp: false,
          error: {
            type: 'error',
            html: `<h4><b>${preStr}</b></h4> 
            <h5>There should be only one list option</h5>`
          }
        }
      }

      return {resp: true, error: null}
    },
    validateConfigData () {
      let config = this.allRows[0].config
      if (config && config[this.gRowObj.message]) {
        let appMessages = config[this.gRowObj.message]
        for (const country of Object.keys(appMessages)) {
          if (!this.activeCountryList.includes(country)) {
            continue
          }
          let countryWiseTranslations = appMessages[country]
          for (const lang of Object.keys(countryWiseTranslations)) {
            let preStr = `${this.gRowObj.message} --> ${country} (${lang})`
            let btnArray = countryWiseTranslations[lang].match(/(?<=\{\{).*?(?=\}\})/g)
            let optionArray = countryWiseTranslations[lang].match(/(?<=\[\[).*?(?=\]\])/g)
            let {resp, error} = this.checkValidations(preStr, btnArray, optionArray, countryWiseTranslations[lang])
            if (!resp && error) {
              this.$swal(error)
              return false
            }
          }
        }
      } else {
        for (const lang of Object.keys(config)) {
          let preStr = `${this.gRowObj.message} --> ${lang}`
          let languageWiseTranslations = config[lang][this.gRowObj.message]
          let btnArray = languageWiseTranslations.match(/(?<=\{\{).*?(?=\}\})/g)
          let optionArray = languageWiseTranslations.match(/(?<=\[\[).*?(?=\]\])/g)
          let {resp, error} = this.checkValidations(preStr, btnArray, optionArray, languageWiseTranslations)
          if (!resp && error) {
            this.$swal(error)
            return false
          }
        }
      }
      return true
    },
    setTranslateSwitch (value = false) {
      this.gRowObj.rowObj.language && this.gRowObj.rowObj.language.forEach((lang) => {
        if (lang.langShortcode !== 'eng') {
          this.translateSwitch[lang.langShortcode] = value
        }
      })
      this.gRowObj.rowObj.country && this.gRowObj.rowObj.country.forEach((country) => {
        this.translateSwitch[country.country] = {}
        country.languages && country.languages.forEach((lang) => {
          this.translateSwitch[country.country][lang.langCode] = value
        })
      })
      this.translateSwitch = JSON.parse(JSON.stringify(this.translateSwitch))
    },
    lockAll () {
      this.setTranslateSwitch(false)
    },
    unlockAll () {
      this.setTranslateSwitch(true)
    },
    async translate () {
      this.loading = true
      // Check if english message is set or not
      const isEnglishMessageSet = (this.gRowObj.rowObj.language && this.gRowObj.rowObj.language.some(lang => lang.langShortcode === 'eng' && lang.message)) ||
        (((this.gRowObj.rowObj.country && this.gRowObj.rowObj.country.find(c => c.country === 'Global') || { languages: [] }).languages.find(l => l.langCode === 'eng') || {}))
      const englishMessage = (this.gRowObj.rowObj.language && this.gRowObj.rowObj.language.find(lang => lang.langShortcode === 'eng') && this.gRowObj.rowObj.language.find(lang => lang.langShortcode === 'eng').message) ||
        (((this.gRowObj.rowObj.country && this.gRowObj.rowObj.country.find(c => c.country === 'Global') || { languages: [] }).languages.find(l => l.langCode === 'eng') || {}).message)

      if (isEnglishMessageSet && englishMessage && englishMessage.trim() !== '') {
        this.loading = true
        const targetLanguages = [...new Set(Object.entries(this.translateSwitch).flatMap(([_, val]) =>
          typeof val === 'boolean'
            ? (val ? [_] : [])
            : Object.entries(val).filter(([_, v]) => v).map(([k]) => k)
        ))]

        if (targetLanguages.length === 0) {
          this.$swal({
            title: 'Failure',
            type: 'error',
            text: 'Please select at least one language to translate'
          })
          this.loading = false
          return
        }

        const messageToBeTranslated = [{eng: englishMessage}]

        // translate and then set it back to the object
        try {
          const response = await api.buildRequest(`getTranslation`, 'POST', {
            messageToBeTranslated,
            targetLanguages
          })
          const translatedContent = response.data.payload.translations[0]

          for (const language in this.gRowObj.rowObj.language) {
            if (this.gRowObj.rowObj.language[language].langShortcode !== 'eng') {
              const langCode = this.gRowObj.rowObj.language[language].langShortcode
              if (translatedContent[langCode]) {
                this.gRowObj.rowObj.language[language].message = translatedContent[langCode]
              }
            }
          }

          if (this.gRowObj.rowObj.country) {
            for (const country of this.gRowObj.rowObj.country) {
              const countryCode = country.country
              if (countryCode !== 'Global') {
                for (const lang of country.languages) {
                  if (this.translateSwitch[countryCode] && this.translateSwitch[countryCode][lang.langCode]) {
                    lang.message = translatedContent[lang.langCode]
                  }
                }
              }
            }
          }
          this.loading = false
        } catch (err) {
          this.$swal({
            title: 'Failure',
            type: 'error',
            text: 'Error in translating message'
          })
          this.loading = false
          return
        }
      } else {
        // Show error that global message is not set
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: 'Please set the global English message first'
        })
      }
    },
    simplifyConfigData () {
      var finalData = {}
      this.allRows[0].configNew.forEach(item => {
        if (item.language) {
          item.language.forEach(function (lang) {
            if (!finalData[lang.langShortcode]) {
              finalData[lang.langShortcode] = {}
            }
            finalData[lang.langShortcode][item.name] = lang.message
          })
        }
        if (item.country) {
          finalData[item.name] = {}
          item.country.forEach(function (country) {
            if (!finalData[country.country]) {
              finalData[item.name][country.country] = {}
            }
            finalData[item.name][country.country] = {}
            country.languages.forEach(function (language) {
              finalData[item.name][country.country][language.langCode] = language['message']
            })
          })
        }
        if (this.allRows[0].campaign === 'APP_LAUNCH') {
          finalData[item.name].displayText = item.displayText
          finalData[item.name].isCustomMessage = item.isCustomMessage
        }
      })
      this.allRows[0].config = finalData
    },
    addOrUpdate (e) {
      // this.loading = true
      console.log(e)
      // this.showModal = true
      // console.log(this.gRowObj)
      this.submitted = true
      this.keywordExistError = false
      // var domainname = window.location.hostname
      // this.primaryLanguageData = [this.domain[domainname].primaryLanguage]
      // this.secondaryLanguageData = [this.domain[domainname].secondaryLanguage]
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let returnMsg = ''
      let filterObj = {}
      if (this.gRowObj.rowObj.language) {
        for (var configLang of this.gRowObj.rowObj.language) {
          filterObj[configLang.langShortcode] = configLang.message
        }
      }
      if (this.gRowObj.rowObj.country) {
        for (var configCountry of this.gRowObj.rowObj.country) {
          filterObj[configCountry.country] = {}
          configCountry.languages.forEach(function (language) {
            filterObj[configCountry.country][language.langCode] = language.message
          })
        }
      }
      let queryParams = {
        selector: {
          id: this.gRowObj.id,
          campaign: this.gRowObj.campaign,
          message: this.gRowObj.message,
          config: {
            [this.gRowObj.message]: filterObj
          },
          isdeleted: false
        }
      }
      if (this.allRows[0].hasOwnProperty('config')) {
        this.gRowObj.rowObj.title = this.gRowObj.message
        this.gRowObj.rowObj.name = this.gRowObj.message
        // if ((this.messageData === this.gRowObj.message || (this.messageData === undefined && !this.allRows[0].config[this.domain[domainname].primaryLanguage].hasOwnProperty(this.gRowObj.message)))) {
        if (this.messageData === this.gRowObj.message || this.messageData === undefined) {
          // this.allRows[0].config[this.domain[domainname].primaryLanguage][this.gRowObj.message] = this.gRowObj.primaryLanguageMsg
          // this.allRows[0].config[this.domain[domainname].secondaryLanguage][this.gRowObj.message] = this.gRowObj.secondaryLanguageMsg
          let indexLangUpdate = this.allRows[0].configNew.findIndex(x => x.title === this.gRowObj.message)
          if (indexLangUpdate >= 0) {
            this.allRows[0].configNew[indexLangUpdate] = this.gRowObj.rowObj
          } else {
            this.allRows[0].configNew.push(this.gRowObj.rowObj)
          }
        // } else if (!this.allRows[0].config[this.domain[domainname].primaryLanguage].hasOwnProperty(this.gRowObj.message)) {
        } else {
          // delete this.allRows[0].config[this.domain[domainname].primaryLanguage][this.messageData]
          // delete this.allRows[0].config[this.domain[domainname].secondaryLanguage][this.messageData]
          // this.allRows[0].config[this.domain[domainname].primaryLanguage][this.gRowObj.message] = this.gRowObj.primaryLanguageMsg
          // this.allRows[0].config[this.domain[domainname].secondaryLanguage][this.gRowObj.message] = this.gRowObj.secondaryLanguageMsg
          let indexLangUpdate = this.allRows[0].configNew.findIndex(x => x.title === this.messageData)
          if (indexLangUpdate >= 0) {
            this.allRows[0].configNew[indexLangUpdate] = this.gRowObj.rowObj
          } else {
            this.allRows[0].configNew.push(this.gRowObj.rowObj)
          }
        }
      } else {
        // this.allRows[0].config = { [this.domain[domainname].primaryLanguage]: {
        //   [this.gRowObj.message]: this.gRowObj.primaryLanguageMsg
        // },
        //   [this.domain[domainname].secondaryLanguage]: {
        //     [this.gRowObj.message]: this.gRowObj.secondaryLanguageMsg
        //   }
        // }
        this.gRowObj.rowObj.title = this.gRowObj.message
        this.gRowObj.rowObj.name = this.gRowObj.message
        this.allRows[0].configNew.push(this.gRowObj.rowObj)
      }
      this.simplifyConfigData()
      let isValid = this.validateConfigData()
      if (!isValid) {
        return
      }
      console.log(this.allRows[0])
      // let self = this
      console.log('queryParams', queryParams)
      api.buildRequest('checkMessageExists', 'POST', queryParams)
      .then(response => {
        console.log(response.data.payload)
          // console.log(response.data.payload.facilities)
        if (response.status === 200) {
          let same = response.data.payload
          console.log('this.messadedata:', response)
          console.log('this.gRowObj.message:', this.gRowObj.message)
          if (this.messageData !== this.gRowObj.message && same) {
            // this.gRowObj.config = this.allRows[0].config
            this.keywordExistError = true
            this.statusMessage = 'Same'
          } else {
            let trimmedObj = {}
            // if (this.gRowObj.primaryLanguageMsg === undefined && this.gRowObj.secondaryLanguageMsg === undefined) {
            //   this.allRows[0].config[this.domain[domainname].primaryLanguage][this.gRowObj.message] = null
            //   this.allRows[0].config[this.domain[domainname].secondaryLanguage][this.gRowObj.message] = null
            // }
            this.gRowObj.campaign = this.gRowObj.campaign.toUpperCase()

            if (this.gRowObj.campaign === 'APP_LAUNCH') {
              this.allRows[0].config[this.gRowObj.message].displayText = this.gRowObj.displayText
              this.allRows[0].config[this.gRowObj.message].isCustomMessage = this.gRowObj.isCustomMessage
            }

            this.gRowObj.config = this.allRows[0].config
            this.gRowObj.campaignType = this.allRows[0].campaignType || 'generic'
            if (this.allRows[0].messageType) {
              this.gRowObj.messageType = this.allRows[0].messageType
            }

            trimmedObj = this.trimJsonObj(this.gRowObj)
            const newRowObj = {
              id: trimmedObj.id,
              campaign: trimmedObj.campaign,
              config: trimmedObj.config,
              data: trimmedObj
            }
            newRowObj.existingMessage = {
              isCustomMessageFlagChanged: this.gRowObj.isCustomMessage !== this.currentCustomMessageStatus,
              isCustomMessage: this.gRowObj.isCustomMessage,
              message: this.gRowObj.message
            }
            console.log('data from saving', newRowObj)
            let params = {}
            this.$emit('closeLoader', true)
            params.newRow = Object.assign({}, newRowObj)
            let apiToCall = 'updateMessages'
            // this.isMessageModalVisible = false
            // self.loading = true
            returnMsg = this.returnMessage
            console.log('message:', returnMsg)
            this.performKeywordOperation(newRowObj, apiToCall, returnMsg)
          }
        }
      }).catch(({ response }) => {
        this.loading = false
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    },
    performKeywordOperation (params, apiToCall, message) {
      // this.loading = true
      // this.isMessageModalVisible = false
      // console.log(`params=${JSON.stringify(params)}`)
      api.buildRequest(apiToCall, 'POST', params)
        .then(response => {
          if (response.status) {
            console.log('updated message')
            this.processComplete()
            this.gRowObj.configNew = this.allRows[0].configNew
            this.gRowObj.newRecord = this.allRows[0].newRecord
            this.gRowObj.languageList = this.allRows[0].languageList
            console.log('allRows', this.allRows)
            this.allRows.unshift(this.gRowObj)
            this.keywordExistError = false
            this.$emit('onSubmit', this.allRows)
            // this.$swal({
            //   type: 'success',
            //   text: response ? response.data.payload.message : message
            // })
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          this.processComplete()
          this.loading = false
          this.isMessageModalVisible = false
          // this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    processComplete () {
      this.loading = false
    },
    trimJsonObj (obj) {
      const trimmedObj = {}
      Object.keys(obj).forEach(function (key) {
        trimmedObj[key] = obj[key]
        if (obj[key] !== undefined && typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim()
        }
      })
      delete trimmedObj._id
      return trimmedObj
    }
  },
  computed: {
    hasRow () {
      // for (let key in this.allRows.config) {
      //   console.log('key', key)
      // }
      // console.log('Given Data', this.allRows)
      console.log('domain name', window.location.hostname)
      // var domainname = window.location.hostname
      if (this.allRows.length > 0) {
        if (this.allRows[0].config) {
          // this.primaryLanguageData = Object.assign({}, this.allRows[0].config[this.domain[domainname].primaryLanguage])
          // this.secondaryLanguageData = Object.assign({}, this.allRows[0].config[this.domain[domainname].secondaryLanguage])
          // this.primaryLangText = this.domain[domainname].primaryLangText
          // this.secondaryLangText = this.domain[domainname].secondaryLangText
          // console.log(this.primaryLangText)
          return Object.keys(this.allRows).length
        } else {
          // this.primaryLangText = this.domain[domainname].primaryLangText
          // this.secondaryLangText = this.domain[domainname].secondaryLangText
          return (this.allRows).length + 1
        }
      }
      // this.primaryLangText = this.domain[domainname].primaryLangText
      // this.secondaryLangText = this.domain[domainname].secondaryLangText
      console.log('all rows count', (this.allRows).length)
      return (this.allRows).length + 1
    }
  },
  data () {
    return {
      translateSwitch: {},
      returnMessage: '',
      statusMessage: '',
      loading: false,
      showModal: false,
      keywordExistError: false,
      isMessageModalVisible: false,
      messageData: this.gRowObj.message,
      submitted: false,
      activeCountryList: [],
      primaryLangText: {},
      secondaryLangText: {},
      primaryLanguageData: {},
      secondaryLanguageData: {},
      popupTitle: 'Add Message',
      gRowObj: {
        id: null,
        campaign: '',
        message: '',
        displayText: '',
        isCustomMessage: false,
        primaryLanguageMsg: '',
        secondaryLanguageMsg: '',
        config: {}
      },
      domain: {
        'localhost': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'dashboard.mynivi.in': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'india-dashboard-staging.herokuapp.com': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'eu-dashboard-staging.herokuapp.com': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        },
        'dashboard.mynivi.ke': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        }
      }
    }
  }
}
</script>
<style>
.m-0 {
  margin: 0
}
  .radio-is-welcome-div {
    display: flex;
    padding-left: 20px;
    width: 200px;
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);    
    height:550px;    
  }

  .modal-header,
  .modal-footer {
    padding: 10px;
    display: inline-block;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-size: 18px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px;
    min-height: 400px;    
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #0D9488;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #0D9488;
    border: 1px solid #0D9488;
    border-radius: 2px;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
  .closeButton {
    position:absolute;
    left:92%;
    top:-1%;
    font-weight: bold;
  }
  .text-red {
    color: red
  }
  .margin-left-20px {
    margin-left: 20px
  }
  .margin-left-5px {
    margin-left: 5px
  }
</style>


// WEBPACK FOOTER //
// addApplicationMessage.vue?1a46c8d9